import { Howl } from 'howler';
import drawSfx from '../../assets/sounds/updown-1-fo.mp3';
import beep from '../../assets/sounds/price-change-beep.wav';
import marker2 from '../../assets/sounds/marker-2.wav';
import marker1 from '../../assets/sounds/marker-1.wav';
import zoomOut from '../../assets/sounds/zoomout.wav';
import placeBet from '../../assets/sounds/place_bet_low.wav';
import timerTick from '../../assets/sounds/timer_tick.mp3';
import volumeToggle from '../../assets/sounds/vol-toggle.mp3';
import error from '../../assets/sounds/error.wav';
import success from '../../assets/sounds/success.wav';
import winner from '../../assets/sounds/winner.wav';
import countDown from '../../assets/sounds/countdown.mp3';
import haki from '../../assets/sounds/haki-effect.mp3';

export const soundLibrary = {
  draw: new Howl({ src: [drawSfx] }),
  beep: new Howl({ src: [beep] }),
  marker2: new Howl({ src: [marker2] }),
  marker1: new Howl({ src: [marker1] }),
  zoomOut: new Howl({ src: [zoomOut] }),
  placeBet: new Howl({ src: [placeBet], volume: 1 }),
  timerTick: new Howl({ src: [timerTick] }),
  volumeToggle: new Howl({ src: [volumeToggle] }),
  error: new Howl({ src: [error] }),
  success: new Howl({ src: [success] }),
  winner: new Howl({ src: [winner] }),
  countDown: new Howl({ src: [countDown], volume: 2 }),
  haki: new Howl({ src: [haki], volume: 1.5 }),
  //click: new Howl({ src: [clickSound] }),
};